import { Injectable } from "@angular/core";
import { getNameStreet } from "src/app/utils/normalizerFunctions";
import { RmDraftService } from "../services/rm-draft.service";
import { RmNormalizadorService } from "../services/rm-normalizador.service";

@Injectable({
    providedIn: 'root'
})
export class RmGlobals {
    constructor(
        private normalizadorService: RmNormalizadorService,
        private draftService: RmDraftService
    ) { }

    updateTotalPrice(rateFtth, ratesMobiles) {
        let totalPrice = 0;
        if (rateFtth != null) {
            totalPrice += parseFloat(rateFtth.rateAmount);
        }
        if (ratesMobiles.length > 0) {
            ratesMobiles.forEach((rate, index) => {
                if (rate) {
                    if (rateFtth != null && index === 0) {
                        totalPrice += parseFloat(rate.rateAmount) - parseFloat(rateFtth.discount);
                    } else {
                        totalPrice += parseFloat(rate.rateAmount);
                    }
                }
            });
        }
        return totalPrice;
    }

    ftthRateIsValid(order, rateMaster) : boolean {
        if (order && order.broadband && order.broadband.rate && rateMaster) {
            const found = rateMaster.ftth.find(rateFtth => order.broadband.rate.rate_id === rateFtth.rate_id);
            return found ? true : false;
        }
        return false;
    }

    mobileRateIsValid(mobile, rateMaster) : boolean {
        if (mobile && mobile.rate && rateMaster && rateMaster.mobile) {
            let ratesMobile = [];
            if (mobile.contract_type === 'prepaid') {
                Array.prototype.push.apply(ratesMobile, rateMaster.mobile.pre.other);
                Array.prototype.push.apply(ratesMobile, rateMaster.mobile.pre.unlimited);
            } else {
                Array.prototype.push.apply(ratesMobile, rateMaster.mobile.post.other);
                Array.prototype.push.apply(ratesMobile, rateMaster.mobile.post.unlimited);
                if (rateMaster.additional && rateMaster.additional.post) {
                    Array.prototype.push.apply(ratesMobile, rateMaster.additional.post);
                }
            }
            const found = ratesMobile.find(rateMovil => rateMovil.rate_id === mobile.rate.rate_id);
            return found ? true : false;
        }
        return false;
    }

    mobileRateIsValidConvergente(order, mobile, rateMaster) : boolean {
        if (order && order.broadband && order.broadband.rate && mobile && mobile.rate && rateMaster && rateMaster.ftth) {
            const found = rateMaster.ftth.find(rateFtth => order.broadband.rate.rate_id === rateFtth.rate_id);
            if (found) {
                const foundMovil = found.mobileRates.find(rateMovil => rateMovil.rate_id === mobile.rate.rate_id);
                return foundMovil ? true : false;
            }
            return false
        }
        return false;
    }

    getDataNormalizar(normalizador, roadTypes) {
        return {
            streetNr: `${normalizador.numeroNormaliza}`,
            streetName: getNameStreet(normalizador.nombreViaNormaliza, roadTypes, 'code'),
            city: normalizador.localidadNormaliza,
            stateOrProvince: normalizador.provinciaNormaliza,
            streetType: this.getTypeStreet(normalizador.tipoViaNormaliza, roadTypes),
            postCode: `${normalizador.codigoPostalNormaliza}`
        };
    }

    async coverageIsValid(broadband, roadTypes) : Promise<boolean> {
        return await this.normalizadorService
            .normalizarHorizontal(this.getDataNormalizar(this.draftService.getNormalizador(broadband), roadTypes))
            .toPromise()
            .then(async (data: any) => {
                // Solucion para que al cambiar el endpoint no falle del comun al rm
                if (data.msg) {
                    data = data.msg;
                }
                if (Array.isArray(data) && data.length > 0) {  
                    let foundGeneral: boolean = false;
                    data.forEach(address => {
                        if (address && address.ospAddressExternalId && address.ospAddressExternalId.length) {
                            const foundArvato = address.ospAddressExternalId.find(arvatoOrGescal => arvatoOrGescal.refId === 'arvato');
                            const foundGescal = address.ospAddressExternalId.find(arvatoOrGescal => arvatoOrGescal.refId === 'gescal');
                            if (foundArvato && foundArvato.externalId === broadband.arvato_code && foundGescal && foundGescal.externalId === broadband.gescal_code) {
                                foundGeneral = address;
                            }
                        }
                    });
                    if (foundGeneral) {
                        return await this.normalizadorService.consultaCobertura(foundGeneral)
                            .toPromise()
                            .then((data: any) => {
                                // Solucion para que al cambiar el endpoint no falle del comun al rm\
                                if (data.msg) {
                                    data = data.msg;
                                }
                                if (data.cimaGescalCode && data.cimaGescalCode !== '' && data.realtechnology && data.realtechnology.length > 0 && data.technology[0] !== 'NINGUNO') {
                                    return true;
                                } else {
                                    return false;
                                }
                            }, (error) => {
                                return false;
                            });
                    }
                    return false;                 
                }
                return false;
            }, error => {
                return false;
            });
    }

    getTypeStreet(value: string, roadTypes): string {
        if (roadTypes && roadTypes.length && value) {
            if (value.toLowerCase() === 'passatge') {
                value = 'pasaje';
            }
            const valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            const tipoVia = roadTypes.filter(item => {
                const codeNormalized = item.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return valueNormalized.toLowerCase() === codeNormalized.toLowerCase();
            });

            if (tipoVia && tipoVia.length) {
                return tipoVia[0].code;
            }
        }
        return 'CALLE';
    }

}